// extracted by mini-css-extract-plugin
export default {"row":"DefaultPlaceholder_row__R+qp9","shine":"DefaultPlaceholder_shine__cTuF5"};